module.exports = __webpack_public_path__ + "static/media/EvilIcons.d662824a.ttf";